import URL from '../helpers/URL.js'

;$(function() {

	function appendToLinks(str) {
		for (let i = 0; i < $(document).find('a').length; i++) {
			let elem = $(document).find('a').eq(i);
			let href = elem.attr('href');

			if (! href)
				continue;
			if (href == '')
				continue;
			if (/^tel:/gi.test(href))
				continue;
			if (href.indexOf(str) > -1)
				continue;

			if (/\?/gi.test(href))
				elem.attr('href', href + '&' + str);
			else
				elem.attr('href', href + '?' + str);
		}
	}

	if (/theme=ui-1/gi.test(URL.search))
		appendToLinks('theme=ui-1');
	if (/theme=ui-2/gi.test(URL.search))
		appendToLinks('theme=ui-2');

});